import { Icon } from '@design/components/icon/Icon';
import { WithNAFallback } from '@design/components/table';
import { formatNumberWithUnit } from '@terminal/widgets/earnings/utils/utils';

import styles from './MonetaryValueCell.module.scss';

/**
 * @deprecated
 */
export const MonetaryValueCell = ({
  value,
  currency = 'USD',
  includeIcon,
  shouldTruncate = false,
}: {
  value?: number;
  currency?: string;
  includeIcon?: boolean;
  shouldTruncate?: boolean;
}) => {
  const priceFormatter = new Intl.NumberFormat(navigator.language, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return (
    <div className={styles.root}>
      {includeIcon && (
        <Icon fillColor="var(--icon-success)" iconName="Sun" size={12} />
      )}
      <WithNAFallback
        value={
          value && (
            <div className={styles.flexRowWrapper}>
              {shouldTruncate
                ? formatNumberWithUnit(value)
                : priceFormatter.format(value)}{' '}
              <div className={styles.currencyLabel}>{currency}</div>
            </div>
          )
        }
      />
    </div>
  );
};
